import {OrganizationType} from "@/libs/supply-chain";

export default [
    {
        path: '/administration/users',
        name: 'administration-users',
        component: () => import('@/views/administration/user/Users.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/administration/users/add',
        name: 'administration-user-add',
        component: () => import('@/views/administration/user/AddEditUser.vue'),
    },
    {
        path: '/administration/users/:id/card',
        name: 'administration-user-card',
        component: () => import('@/views/administration/user/AddEditUser.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/administration/suppliers',
        name: 'administration-suppliers',
        component: () => import('@/views/administration/organization/Suppliers.vue'),
    },
    {
        path: '/administration/customers',
        name: 'administration-customers',
        component: () => import('@/views/administration/organization/Customers.vue'),
    },
    {
        path: '/administration/internal-organizations',
        name: 'administration-internal-organizations',
        component: () => import('@/views/administration/organization/internal/Grid.vue'),
    },
    {
        path: '/administration/suppliers/:id/card',
        name: 'administration-supplier-edit',
        component: () => import('@/views/administration/organization/AddEditSupplier.vue'),
        props: (route) => {
            return {...route.params, type: OrganizationType.SUPPLIER};
        }
    },
    {
        path: '/administration/add/supplier',
        name: 'administration-supplier-add',
        component: () => import('@/views/administration/organization/AddEditSupplier.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/administration/internal-organizations/:id/card',
        name: 'administration-internal-edit',
        component: () => import('@/views/administration/organization/internal/AddEdit.vue'),
        props: (route) => {
            return {...route.params, type: OrganizationType.INTERNAL};
        }
    },
    {
        path: '/administration/add/:type',
        name: 'administration-organization-add',
        component: () => import('@/views/administration/organization/AddEditOrganization.vue'),
        props: (route) => {
            return route.params;
        }
    },

    {
        path: '/administration/subscribers',
        name: 'administration-subscribers',
        component: () => import('@/views/administration/subscriber/Grid.vue'),
    },
    {
        path: '/administration/subscribers/add',
        name: 'administration-subscribers-add',
        component: () => import('@/views/administration/subscriber/Add.vue'),
    },
    {
        path: '/administration/subscribers/:id/card',
        name: 'administration-subscribers-edit',
        component: () => import('@/views/administration/subscriber/Edit.vue'),
        props: (route) => {
            return route.params;
        }
    },

    //  Production Unit
    {
        path: '/administration/production-units',
        name: 'administration-production-units',
        component: () => import('@/views/administration/organization/production-unit/Grid.vue'),
    },
    {
        path: '/administration/suppliers/:sid/card/production-units/add',
        name: 'administration-production-units-add',
        component: () => import('@/views/administration/organization/production-unit/Edit.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/administration/suppliers/:sid/card/production-units/:id/card',
        name: 'administration-production-units-edit',
        component: () => import('@/views/administration/organization/production-unit/Edit.vue'),
        props: (route) => {
            return route.params;
        }
    },

    //  Legislations
    {
        path: '/administration/legislations',
        name: 'administration-legislations',
        component: () => import('@/views/administration/legislation/Grid.vue'),
    },
    {
        path: '/administration/legislations/add',
        name: 'administration-legislations-add',
        component: () => import('@/views/administration/legislation/CreateEdit.vue'),
    },
    {
        path: '/administration/legislations/:id/card',
        name: 'administration-legislations-edit',
        component: () => import('@/views/administration/legislation/CreateEdit.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/administration/legislations/question-groups',
        name: 'administration-legislation-question-groups',
        component: () => import('@/views/administration/legislation/question-groups/Grid.vue'),
    },
    {
        path: '/administration/legislations/question-groups/create',
        name: 'administration-legislation-question-group-create',
        component: () => import('@/views/administration/legislation/question-groups/CreateEdit.vue'),
    },
    {
        path: '/administration/legislations/question-groups/:id/card',
        name: 'administration-legislation-question-group-card',
        component: () => import('@/views/administration/legislation/question-groups/CreateEdit.vue'),
        props: (route) => {
            return route.params;
        }
    },

    //  Pages

    //  System content

    {
        path: '/administration/pages/system',
        name: 'administration-pages-system-articles',
        component: () => import('@/views/administration/pages/system-content/Grid'),
    },
    {
        path: '/administration/pages/system/:id',
        name: 'administration-pages-system-articles-edit',
        component: () => import('@/views/administration/pages/system-content/Edit'),
        props: (route) => {
            return route.params;
        }
    },

    //  Category
    {
        path: '/administration/pages/categories',
        name: 'administration-pages-categories',
        component: () => import('@/views/administration/pages/categories/Grid'),
    },
    {
        path: '/administration/pages/categories/add',
        name: 'administration-pages-categories-add',
        component: () => import('@/views/administration/pages/categories/AddOrEdit'),
    },
    {
        path: '/administration/pages/categories/:id',
        name: 'administration-pages-categories-edit',
        component: () => import('@/views/administration/pages/categories/AddOrEdit'),
        props: (route) => {
            return route.params;
        }
    },

    //  News
    {
        path: '/administration/pages/news',
        name: 'administration-pages-news',
        component: () => import('@/views/administration/pages/news/Grid'),
    },
    {
        path: '/administration/pages/news/add',
        name: 'administration-pages-news-add',
        component: () => import('@/views/administration/pages/news/AddOrEdit'),
    },
    {
        path: '/administration/pages/news/:id',
        name: 'administration-pages-news-edit',
        component: () => import('@/views/administration/pages/news/AddOrEdit'),
        props: (route) => {
            return route.params;
        }
    },

    //  Import
    {
        path: '/administration/import/candidate-list',
        name: 'administration-import-candidate-list',
        component: () => import('@/views/administration/import/CandidateList'),
    },

    {
        path: '/administration/import/suppliers',
        name: 'administration-import-suppliers',
        component: () => import('@/views/administration/import/Suppliers.vue'),
    },

    //  Product
    {
        path: '/administration/product/general-product-statements',
        name: 'administration-product-general-product-statements',
        component: () => import('@/views/administration/product/general-product-statement/Grid.vue'),
    },
    {
        path: '/administration/product/general-product-statements/add',
        name: 'administration-product-general-product-statements-add',
        component: () => import('@/views/administration/product/general-product-statement/AddEdit.vue'),
    },
    {
        path: '/administration/product/general-product-statements/:id',
        name: 'administration-product-general-product-statements-edit',
        component: () => import('@/views/administration/product/general-product-statement/AddEdit.vue'),
        props: (route) => {
            return route.params;
        }
    },

    //  Substance
    {
        path: '/administration/substance/regulated-substances',
        name: 'administration-substances-regulated-substances',
        component: () => import('@/views/administration/substance/regulated-substances/Grid.vue'),
    },
    {
        path: '/administration/substance/regulated-substances/:id',
        name: 'administration-substances-regulated-substances-edit',
        component: () => import('@/views/administration/substance/regulated-substances/Edit.vue'),
        props: (route) => {
            return route.params;
        }
    },
];
